import { useState, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import NAVBAR from "components/navbar";
import config from "config";
import MESSAGE from "components/message";
import api from "services/api";
import DIALOGWAIT from "dialog/dialogwait";
import RADIO from "components/radio";
import { Buffer } from 'buffer';
import CAMERACOMPONENT from "components/cameraimagem";
import { CidadeContext } from "services/cidade";
const { v4: uuidv4 } = require('uuid');

function AdminNotificacao() {
    const myRefreshToken = '';
    const [titulo, setTitulo] = useState('');
    const [corpo, setCorpo] = useState('');
    const [imagem, setImagem] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false);
    const [tipoenvio, setTipoEnvio] = useState('N');
    const [todos, setTodos] = useState('I');

    const navigate = useNavigate();

    const {cod_cidade} = useContext(CidadeContext)

    async function enviaMensagem() {

        // Limitar tamanho da imagem antes de enviar
        const dadosBase = {
            "type": "M",
            "title": titulo,
            "body": corpo,
            "image": `${config.BASEIMG}${imagem}`,
            "cod_cidade": cod_cidade,
        };

        setLoading(true);

        try {
            // Primeiro POST para notificação
            const postResponse = await api.post(`${config.NOTIFICACAO}?p=${tipoenvio}`, dadosBase);

            if (postResponse.status === 202) {
                try {
                    // GET para obter tokens de registro
                    const getResponse = await api.get(`${config.PUSHNOTIFICATION}/registration?TODOS=${todos}&cod_cidade=${cod_cidade}`);

                    if (getResponse.status === 200) {
                        const registrationTokens = getResponse.data;
                        const username = config.BASICAPI;
                        const password = config.BASICAPI;
                        const token = Buffer.from(`${username}:${password}`).toString('base64');
                        const headers = {
                            'Authorization': `Basic ${token}`,
                            'Content-Type': 'application/json'
                        };

                        // Função para dividir em lotes de 500 e garantir JSON < 10MB
                        function splitTokens(tokens, maxPerBatch = 500, maxJsonSize = 10 * 1024 * 1024) {
                            let batches = [];
                            let currentBatch = [];
                            let currentSize = 0;
                            for (let i = 0; i < tokens.length; i++) {
                                currentBatch.push(tokens[i]);
                                // Estimar tamanho do JSON
                                const tempDados = { ...dadosBase, registrationTokens: currentBatch };
                                const tempSize = Buffer.byteLength(JSON.stringify(tempDados), 'utf8');
                                if (currentBatch.length >= maxPerBatch || tempSize > maxJsonSize) {
                                    // Remove último token se excedeu tamanho
                                    if (tempSize > maxJsonSize) {
                                        currentBatch.pop();
                                    }
                                    batches.push([...currentBatch]);
                                    currentBatch = [];
                                }
                            }
                            if (currentBatch.length > 0) {
                                batches.push(currentBatch);
                            }
                            return batches;
                        }

                        const batches = splitTokens(registrationTokens);
                        let allFailedTokens = [];
                        for (let batch of batches) {
                            const dados = { ...dadosBase, registrationTokens: batch };
                            try {
                                const sendPushResponse = await axios.post(`https://horse.opnet.com.br${config.SENDPUSH}`, dados, { headers });
                                if (sendPushResponse.data.failedTokens !== null && Array.isArray(sendPushResponse.data.failedTokens)) {
                                    allFailedTokens = allFailedTokens.concat(sendPushResponse.data.failedTokens);
                                }
                            } catch (sendPushError) {
                                console.error('Erro ao enviar push notification para lote:', sendPushError);
                                setMensagem('Erro ao enviar push notification para um dos lotes.');
                            }
                        }

                        // PATCH para lidar com tokens falhos
                        if (allFailedTokens.length > 0) {
                            const patchDados = { 'failedTokens': allFailedTokens };
                            try {
                                await api.patch(`${config.PUSHNOTIFICATION}/registration`, patchDados);
                            } catch (patchError) {
                                console.error('Erro no PATCH:', patchError);
                            }
                        }

                        setLoading(false);
                        navigate('/');
                    } else {
                        throw new Error('Falha ao obter tokens de registro');
                    }
                } catch (getError) {
                    console.error('Erro no GET:', getError);
                    setMensagem('Erro ao buscar tokens de registro.');
                    setLoading(false);
                }
            } else {
                throw new Error(postResponse.response.data.erro || 'Erro desconhecido no POST inicial');
            }
        } catch (postError) {
            console.error('Erro no POST inicial:', postError);
            setMensagem(postError.message || 'Erro ao enviar a notificação.');
            setLoading(false);
        }
    }


    return <div>
        <NAVBAR />
        <div className='mt-page'>
            <MESSAGE msg={mensagem} />
            <form>
                <div className="row">
                    <div className="col-md-10">
                        <label htmlFor="forTitulo" className="form-label">Titulo</label>
                        <input type="text"
                            value={titulo}
                            onChange={(e) => setTitulo(e.target.value)}
                            className="form-control" id="forTitulo" />
                    </div>
                    <div className="col-md-10">
                        <label htmlFor="forCorpo" className="form-label">Mensagem</label>
                        <textarea type="text"
                            maxLength={2000}
                            value={corpo}
                            onChange={(e) => setCorpo(e.target.value)}
                            className="form-control" id="forCorpo" />
                    </div>
                    <div className="col-md-10">
                        <label htmlFor="forImagem" className="form-label">Link Imagem</label>
                        <CAMERACOMPONENT
                            heigth={200}
                            width={200}
                            foto={imagem}
                            setFoto={setImagem}
                            className={'foto-notificacao'}
                            base64={false}
                            //setImgB64={setB64Foto}
                            nomedoarquivo={`not${ uuidv4() }.png`}
                            diretorio={'imgban'}
                        />
                        <input type="text" value={imagem} disabled />
                    </div>
                    <div className="col-md-10">
                        <label htmlFor="forTEnvio" className="form-label">Tipo envio</label>
                        <RADIO
                            chave={'forTEnvio'}
                            avalores={['N', 'P', 'I']}
                            alabel={['Todos', 'Parceiros', 'Eu']}
                            setValor={setTipoEnvio}
                            valor={tipoenvio}
                        />
                    </div>
                    <div className="col-md-10">
                        <label htmlFor="forTODOS" className="form-label">Push</label>
                        <RADIO
                            chave={'forTODOS'}
                            avalores={['A', 'P', 'I']}
                            alabel={['Todos', 'Parceiros', 'Eu']}
                            setValor={setTodos}
                            valor={todos}
                        />
                    </div>

                    <div className="col-md-12 mt-5">
                        <button type="button" className="btn btn-info btn-large" onClick={(e) => enviaMensagem()}>Notificacao </button>
                    </div>
                </div>
            </form>
        </div>
        <DIALOGWAIT
            trigger={loading}
            setTrigger={setLoading}
        />
    </div>
}

export default AdminNotificacao;